import React from "react";
import { Container, Row } from "react-bootstrap";
import Carousel from "../Components/Carousel/CarouselItem";
const Testimonials = () => {
  const mockTestimonial = [
    {
      id: 0,
      header: "It’s just incredible!",
      body: "It’s just 1 month since I’m using Spend.In to manage my business expenses, but the result is very satisfying! My business finance now more neat than before, thanks to Spend.In!",
      img: "http://creativeedtech.weebly.com/uploads/4/1/6/3/41634549/published/avatar.png?1487742111",
      author: "Jimmy Bartney",
      author_info: "Product Manager at Picko Lab",
    },
    {
      id: 1,
      header: "Satisfied User Here!",
      body: "It’s just 1 month since I’m using Spend.In to manage my business expenses, but the result is very satisfying! My business finance now more neat than before, thanks to Spend.In!",
      img: "http://creativeedtech.weebly.com/uploads/4/1/6/3/41634549/published/avatar.png?1487742111",
      author: "Jimmy Bartney",
      author_info: "Product Manager at Picko Lab",
    },
    {
      id: 2,
      header: "No doubt, Spend.In is the best!",
      body: "It’s just 1 month since I’m using Spend.In to manage my business expenses, but the result is very satisfying! My business finance now more neat than before, thanks to Spend.In!",
      img: "http://creativeedtech.weebly.com/uploads/4/1/6/3/41634549/published/avatar.png?1487742111",
      author: "Jimmy Bartney",
      author_info: "Product Manager at Picko Lab",
    },
    {
      id: 3,
      header: "Satisfied User Here!",
      body: "It’s just 1 month since I’m using Spend.In to manage my business expenses, but the result is very satisfying! My business finance now more neat than before, thanks to Spend.In!",
      img: "http://creativeedtech.weebly.com/uploads/4/1/6/3/41634549/published/avatar.png?1487742111",
      author: "Jimmy Bartney",
      author_info: "Product Manager at Picko Lab",
    },
    {
      id: 4,
      header: "It’s just incredible!",
      body: "It’s just 1 month since I’m using Spend.In to manage my business expenses, but the result is very satisfying! My business finance now more neat than before, thanks to Spend.In!",
      img: "http://creativeedtech.weebly.com/uploads/4/1/6/3/41634549/published/avatar.png?1487742111",
      author: "Jimmy Bartney",
      author_info: "Product Manager at Picko Lab",
    },
  ];
  return (
    <section className="testimonial-section section">
      <Container>
        <Row className="section-head text-center">
          <span className="lessopacity">What They Say?</span>
          <h2 className="white">
            Check what our clients <br /> are saying
          </h2>
        </Row>
        <Row className="testimonial-container">
          <Carousel props={mockTestimonial} />
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;
